import initFirebase from "firebaseConfig/config";
import { projectStorage } from "firebaseConfig/config";

initFirebase();

export { projectStorage };
